/* * @Author: ligai  */
import SearchBox from './search.vue'
import HotSearch from './hot-search.vue'
import ShopCartAnimation from '../shop-cart-animation'
import Api from '../api.js'
import response from 'fe-coms/utils/response'
import { mapState, mapGetters } from 'vuex'
import i18n from '../i18n.js'
import createDOMPurify from 'dompurify'
const DOMPurify = createDOMPurify(window)
const pageText = window.fe.getPageText(i18n)
export const mixin = {
  components: {
    SearchBox,
    HotSearch,
    ShopCartAnimation
  },
  props: {
    // name: {
    //   type: String,
    //   default: ''
    // },
    isFixed: {
      type: Boolean,
      default: false
    },
    supplierId: {
      type: Number,
      default: null
    },
    // currentActive: {
    //   type: String,
    //   default: '0'
    // },
    // currentSearch: {
    //   type: String,
    //   default: '0'
    // },
    // mallNameType: {
    //   type: Number,
    //   default: 0
    // },
    platform: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      path: this.$route.path,
      pageText,
      DOMPurify,
      pageInfo: {},
      currentActive: this.$route.query.currentActive || '0',
      currentSearch: this.$route.query.currentActive || '0',
      isResponse: false,
      mallName: '',
      mallNameType: 0,
      isGetCity: true,
      supplyInfo: {},
      supplyEvalInfo: {},
      // 不同路由header有那些内容
      // routerHasMap: {
      //   'main': ['NavMenu', 'Hot'],
      //   'channel': ['NavMenu'],
      //   'store': ['NavMenu']
      // },
      // // 搜索样式
      // searchStyle: {
      //   'main-search': ['main', 'store', 'store-shop', 'channel', 'list', 'supplier-shop', 'scene-list', 'scene-detail'],
      //   'right-search': ['info', 'compare-price', 'cart', 'req']
      // },
      supplierIdMap: {
        '-1': 'lingyong_index',
        '-2': 'lijiu_index'
      },
      pathMap: {
        '/demand-portal': 'demand-portal'
      },
      mallSkuId: '' // 商品id
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (n, o) {
        if (this.path === this.$route.path) {
          this.name = this.$route.query.q || this.$route.query.materielCode || ''
          this.getPageInfo()
        }
      }
    },
    supplierId: {
      handler (n, o) {
        if (n !== 'null' && n && n > 0) {
          // 获取供应商信息
          this.getSupplyInfoBySuId()
          // 获取供应商评分信息
          this.getSupplierEvalInfo()
        }
        if (n < 0) {
          this.getPageInfo()
        }
      },
      immediate: true
    }
  },
  methods: {
    variableReplace: window.fe.variableReplace,
    async getPageInfo () {
      if (this.$route.query && this.$route.query.pageInfo) {
        this.pageInfo = JSON.parse(this.$route.query.pageInfo)
        this.getData()
        this.getPageName()
        return
      }
      let pageCode = this.$route.params?.id || ''
      let api = Api.pageGet
      let params = {
        code: pageCode || this.supplierIdMap[String(this.supplierId)] || this.pathMap[this.$route.path] || 'index'
      }
      let res = await response(this.$http(api.type, api.url, params))
      if (res.isOk) {
        this.pageInfo = res.content || {}
        this.getData()
        if (this.pageInfo.sysPurPageCode) {
          this.getPageName()
        }
      }
    },
    check_is_img (url) {
      return (url.match(/\.(jpeg|jpg|png|bmp|gif|svg)$/) !== null)
    },
    // 获取商城标题
    async getPageName () {
      let api = Api.pageName
      let params = {
        sysPurPageCode: this.pageInfo.sysPurPageCode || Number(this.$route.query?.pageInfo?.sysPurPageCode)
      }
      let res = await response(this.$http(api.type, api.url, params))
      if (res.isOk) {
        this.mallName = res.content || ''
        this.mallNameType = this.check_is_img(this.mallName) ? 1 : 0
        this.$emit('update:mallNameType', this.mallNameType)
        if (this.mallNameType === 0) {
          document.title = this.mallName
        }
      }
    },
    // 获取用户数据
    async getData () {
      let api = Api.homeBasic
      let params = {
        set: [1, 2, 3, 4, 5],
        sysPurPageCode: this.pageInfo.sysPurPageCode
      }
      let res = await response(this.$http(api.type, api.url, params))

      //装修中。。。

      if (res.isOk) {
        this.setStore(res.content)
        this.isResponse = true
      }
    },
    setStore (data) {
      this.$store.commit('SET_USERINFO', data.userVo || {})
      this.$store.commit('SET_USERINFO_TEMPLATE', data.userInfoLocation ?? 0)
      // 取本地缓存的地址
      const cacheSite = window.localStorage.getItem('cacheNoLoginSite') || null
      if ((!data.thisSite || (!data.thisSite.cityCode && !data.thisSite.provinceCode)) && !cacheSite) {
        this.$emit('noSite')
        this.isGetCity = false
      } else {
        this.isGetCity = true
        if (data.userVo) {
          this.$store.commit('SET_SITE', data.thisSite)// 地区
        } else {
          const cacheSite = window.localStorage.getItem('cacheNoLoginSite') || null
          if (cacheSite) {
            this.$store.commit('SET_SITE', JSON.parse(cacheSite))
          } else {
            this.$store.commit('SET_SITE', data.thisSite)
            window.localStorage.setItem('cacheNoLoginSite', JSON.stringify(data.thisSite))
          }
        }
      }
      this.$store.commit('SET_CARTCOUNT', data.shoppingcartCount)// 购物车数量
      this.$store.commit('SET_LOGOINFO', {
        logoUrl: data.header.logoUrl,
        logoLink: data.header.logoLink
      })
      this.$store.commit('SET_ISSEARCHCENTER', data.header.site)
      this.$store.commit('SET_NONDIRTYPE', data.nonCateConfig?.nonDirType || '')
      this.$store.commit('SET_NONDIRLINK', data.nonCateConfig?.nonDirLink || '')
      this.$store.commit('SET_ISFUNCTIONDEPARTMENT', data.nonCateConfig?.isexist || null)
      this.$store.commit('SET_CHANNELMENU', DOMPurify.sanitize(data.header.channelMenu, {ADD_ATTR: ['target']}))
      this.$store.commit('SET_CHANNELMENU_SHOW', data.header.channelMenuShowType)
      this.$store.commit('SET_BOTTOMCONTENT', DOMPurify.sanitize('<div style="display: none;"></div>' + data.bottomContent, {ADD_ATTR: ['target']}))
      this.$store.commit('SET_HEADERTOPCONTENT', DOMPurify.sanitize('<div style="display:none"></div>' + data.header.topContent, {ADD_ATTR: ['target']}))
      this.$nextTick(() => {
        // 设置高亮
        this.setCurrentitem()
      })
    },
    /**
     * 获取供应商信息
     * @returns {Promise<void>}
     */
    async getSupplyInfoBySuId () {
      let api = Api.getSupplyInfoBySuId
      let res = await response(this.$http(api.type, api.url, {supplierId: this.supplierId}))
      if (res.isOk) {
        this.supplyInfo = res.content || {}
        if (this.$route.name === 'supplier-shop' || this.$route.name === 'store-shop') {
          document.title = this.supplyInfo.name
        }
      }
    },
    /**
     * 获取供应商评分
     * @returns {Promise<void>}
     */
    async getSupplierEvalInfo () {
      let api = Api.getSupplierEvalInfo
      let res = await response(this.$http(api.type, api.url, {supplierId: this.supplierId}))
      if (res.isOk) {
        this.supplyEvalInfo = res.content || {}
      }
    },
    setCurrentitem () {
      if (this.$refs.channel) {
        let $lis = this.$refs.channel.querySelectorAll('.channel>li')
        for (let i = 0; i < $lis.length; i++) {
          let $href = $lis[i].querySelector('a').href
          let path = this.$route.path
          // 重置导航样式
          $lis[i].querySelector('a').className = 'font-color-hover-primary'
          $lis[i].querySelector('a').style.fontWeight = 'none'
          $lis[i].className = 'font-color-hover-primary'
          if ($href.split('#')[1] === path) {
            $lis[i].querySelector('a').className = 'font-color-primary'
            $lis[i].querySelector('a').style.fontWeight = 'bold'
            $lis[i].className = 'font-color-primary current-li'
          }
        }
      }
    }
  },
  created () {
    this.mallSkuId = this.$route.params.mallSkuId || this.$route.query.mallSkuId || ''
  },
  computed: {
    ...mapGetters(['nonCatalogNameLabel']),
    // // 当前搜索样式
    // currentSearchStyle () {
    //   let pathName = this.$route.name
    //   for (let key in this.searchStyle) {
    //     if (this.searchStyle[key].includes(pathName)) {
    //       return key
    //     }
    //   }
    //   return 'main-search'
    // },
    getRouter () {
      return this.$route.name
    },
    // 使用对象展开运算符将 getter 混入 computed 对象中
    // 把 `this.cartCount` 映射为 `this.$store.getters.cartCount`
    ...mapState({
      number: state => state.cart.cartCount,
      isCenter: state => state.user.isCenter,
      logoUrl: state => state.user.logoUrl,
      logoLink: state => state.user.logoLink,
      channelMenu: state => state.user.channelMenu,
      channelMenuShowType: state => state.user.channelMenuShowType,
      isFunctionDepartment: state => state.user.isFunctionDepartment,
      nonDirType: state => state.user.nonDirType,
      nonDirLink: state => state.user.nonDirLink,
      isAuth: state => state.user.isAuth
    })
  }
}
